import React from 'react';
import InfoTooltip from '../tooltips/InfoTooltip';
import CountField from '../fields/CountField';
import {useSelector} from 'react-redux';
import FeatureField from '../fields/FeatureField';
import {maxLength255} from '../../../core/form/Validators';
import Error from '../fields/Error';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import Tooltips from '../../helpers/fieldTooltips';

function NumberOfSources() {
    const feature = useSelector(state => state.orderOptions.data.features.usedSource);

    const {isVisible} = useFieldRules('source');
    useSyncedField('source', 'int');

    if (!isVisible) return null;

    return (
        <div className="form-row m-0">
            <div className="form-group form-control-pages">
                <div className="form-label d-flex">
                    Number of sources
                    <InfoTooltip>
                        <p>{Tooltips.source}</p>
                    </InfoTooltip>
                </div>
                <div className="calculator-pages">
                    <CountField
                        name="source"
                        validate={maxLength255}
                    />
                    <Error name="source" />
                </div>
            </div>
            {feature && feature.enable && (
                <div className="form-group form-control-used-sources">
                    <FeatureField name="usedSource" feature={feature} />
                </div>
            )}
        </div>
    );
}

export default NumberOfSources;
